module.exports = __webpack_public_path__ + "img/white_mobile.87338cd5.png";